import { Container, Row, Col, Nav } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagramSquare,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import PrivacyPolicyScreen from "../screens/PrivacyPolicy";

const Footer = () => {
  const footerYear = new Date().getFullYear();
  return (
    <>
      <footer>
        <Container>
          <Row
            style={{
              height: "50px",
              backgroundColor: "#1091ab",
              marginBottom: "20px",
            }}
          >
            <Col
              style={{
                height: "50px",
                backgroundColor: "#1091ab",
                justifyContent: "space-evenly",
                alignItems: "center",
                display: "flex",
                color: "white",
              }}
              className="text-center py-3"
            >
              Zpotter Technologies LLP &copy; {footerYear}
              <Nav.Link href="https://www.facebook.com/profile.php?id=61560699947674">
                <FaFacebook />
              </Nav.Link>
              <Nav.Link href="">
                <FaSquareXTwitter />
              </Nav.Link>
              <Nav.Link href="">
                <FaInstagramSquare />
              </Nav.Link>
              <Nav.Link href="">
                <FaYoutube />
              </Nav.Link>
              <Nav.Link href="">
                <FaLinkedin />
              </Nav.Link>
            </Col>
            <Col
              className="text-center py-3"
              style={{
                height: "50px",
                backgroundColor: "#1091ab",
                justifyContent: "space-evenly",
                alignItems: "center",
                display: "flex",
                color: "white",
              }}
            >
              <Nav.Link href="/privacyPolicy">Privacy Policy</Nav.Link>
              <Nav.Link href="/terms-and-conditions">
                Terms and Conditions
              </Nav.Link>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
